export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            有任何观影建议或合作意向，欢迎随时联系我们
          </p>
        </div>
        <div className="max-w-lg mx-auto bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
            <i className="ri-mail-send-fill text-2xl text-accent-500"></i>
          </div>
          <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-3">投稿与咨询</h3>
          <p className="text-foreground-500 text-sm leading-relaxed mb-4">
            如需推荐影片、反馈观影问题或洽谈商务合作，请通过以下方式联系我们。我们会在24小时内回复您的留言。
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-lg border border-background-200/70 text-foreground-700 text-sm">
            <i className="ri-mail-line text-primary-500"></i>
            <span>contact@68cinema.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}